import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertComponent } from '../components/alert/alert.component';

interface Alert {
    icon: string;
    type: 'error' | 'warning' | 'success';
    value: string;
}

@Injectable({ providedIn: 'root' })
export class AlertService {
    currentAlert: BehaviorSubject<Alert | null> = new BehaviorSubject<Alert | null>(null);
    isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private snackBar: MatSnackBar) {}

    alertError(message: string, duration: number = 10000) {
        this.setLoading(false);
        if(message?.toString()?.toLowerCase()?.startsWith('warn')) {
            return this.alertWarning(message);
        }
        if (message) console.error(message);
        const displayMessage = message ?? 'An unexpected error occurred';
        this.currentAlert.next({ icon: 'exclamation-triangle', type: 'error', value: displayMessage });
        this.openSnackBar('Error', { message: displayMessage, type: 'error' }, duration);
        setTimeout(() => {
            this.currentAlert.next(null);
        }, duration);
    }

    alertWarning(message: string) {
        this.setLoading(false);
        console.warn(message);
        this.currentAlert.next({ icon: 'exclamation-triangle', type: 'warning', value: message });
        this.openSnackBar('Warning', { message: message, type: 'warning' });
        setTimeout(() => {
            this.currentAlert.next(null);
        }, 4000);
    }

    alertSuccess(message: string) {
        this.setLoading(false);
        console.log(message);
        this.currentAlert.next({ icon: 'check', type: 'success', value: message });
        this.openSnackBar('Success', { message: message, type: 'success' });
        setTimeout(() => {
            this.currentAlert.next(null);
        }, 4000);
    }

    openSnackBar(action: string, data: any, duration: number = 4000) {
        this.snackBar.openFromComponent(AlertComponent, {
            data,
            duration,
            verticalPosition: 'bottom', // 'top' or 'bottom'
            horizontalPosition: 'center', // 'start', 'center', or 'end'
        });
    }

    setLoading(isLoading: boolean) {
        this.isLoading.next(isLoading);
    }

    getLoading() {
        return this.isLoading.asObservable();
    }
}
